import { useMatches } from 'react-router-dom';

export const useRouteHandleData = () => {
    const matches = useMatches();
    const lastMatch = matches[matches.length - 1];
    return lastMatch?.handle;
};
